export function removeUndefined(obj: Record<string, any>): Record<string, any> {
  for (const key of Object.keys(obj)) {
    if (Array.isArray(obj[key])) {
      // Array
      for (const element of obj[key] as Record<string, unknown>[]) {
        if (element !== null) {
          removeUndefined(element);
        }
      }
    } else if (
      Object.prototype.toString.call(obj[key]) === '[object Object]' &&
      obj[key] !== null
    ) {
      // Object
      obj[key] = removeUndefined(obj[key]);
    } else {
      // value
      if (obj[key] === undefined) {
        delete obj[key];
      }
    }
  }

  return obj;
}

export const randomiseOrder = (array: any[]) =>
  array.sort(() => Math.random() - 0.5);

/**
 * This is used for merging nested objects
 * Specifically was implemented for use with overriding serializers (see [...categpry])
 * Ripped from SO, and looked over for veritication
 * Couldn't be bothered changing to ts when it is for the sole above purpose.
 * If you use it for something else, maybe convert it
 */

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export async function copyLink(
  textForClipboard: string,
  onCopied: () => void,
  onFailed: () => void
) {
  // Check if the nav clipboard  API is available, i.e. safari <14 does not support.
  if (navigator.clipboard) {
    navigator.clipboard.writeText(textForClipboard).then(
      () => {
        // Show copied message if clipboard returns successfully
        onCopied();
      },
      () => {
        // Show copy fail message if clipboard writing fails, i.e. permissions blocked
        onFailed();
      }
    );
  } else {
    // We don't have the navigator.clipboard API available, so workaround is this...
    // TODO: remove this when Safari support is >13.1
    const textField = document.createElement('textarea');
    textField.innerText = textForClipboard;
    try {
      if (document.activeElement) {
        document.activeElement.appendChild(textField);
      } else {
        document.body.appendChild(textField);
      }
      textField.setSelectionRange(0, 99999);
      // Deprecated but have to use this as only mechanism available for older browsers
      document.execCommand('copy');
      textField.remove();

      onCopied();
    } catch (err) {
      onFailed();
    }
  }
}

// Create a hash of a file to verify what is uploaded to s3
// this cannot live in crypto.js file because node:crypto can only be imported serverside, this function is used client side
export const computeSHA256FromFile = async (file: File | Blob) => {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return hashHex;
};
